import React from 'react';
import { PRIORITY_COLORS, PRIORITY_LABELS, type TicketPriority } from './statuses';

interface Props {
  priority: TicketPriority | string;
  size?: 'sm' | 'md';
}

const PRIORITY_ICONS: Record<TicketPriority, string> = {
  urgent: '↑↑',
  high: '↑',
  normal: '→',
  low: '↓',
};

export const TicketPriorityPill: React.FC<Props> = ({ priority, size = 'md' }) => {
  const key = (priority as TicketPriority) in PRIORITY_COLORS ? (priority as TicketPriority) : 'normal';
  const colors = PRIORITY_COLORS[key];
  const label = PRIORITY_LABELS[key] || priority;
  const icon = PRIORITY_ICONS[key];

  const isSmall = size === 'sm';

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 5,
        padding: isSmall ? '2px 8px' : '4px 10px',
        borderRadius: 100,
        background: colors.bg,
        color: colors.text,
        fontSize: isSmall ? 11 : 12,
        fontWeight: 600,
      }}
    >
      <span style={{ fontWeight: 700 }}>{icon}</span>
      {label}
    </span>
  );
};
